/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    &.color-1 {
      fill: #4eccf4
    }
    &.color-2 {
      fill: #009fe3
    }
     &.color-3 {
      fill: #d4f7ff
    }
  }
`

export default class DiaIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11.722" viewBox="0 0 14 11.722" css={Color}>
        <g id="그룹_6270" data-name="그룹 6270" transform="translate(-1685 -1028)">
          <path id="패스_5344" className="color-1 attendance-color-1" data-name="패스 5344" d="M20.409,49.583a.481.481,0,0,1,.378.182l2.549,3.225a.5.5,0,0,1,.127.363.511.511,0,0,1-.138.314l-6.2,6.507a.174.174,0,0,1-.09.049.157.157,0,0,1-.031,0,.149.149,0,0,1-.031,0,.174.174,0,0,1-.091-.049l-6.2-6.507a.5.5,0,0,1-.013-.677l2.545-3.238a.505.505,0,0,1,.374-.169h6.827m0-.537H13.581a1.04,1.04,0,0,0-.774.348l-2.566,3.264a1.008,1.008,0,0,0-.238.727,1.031,1.031,0,0,0,.283.651l6.2,6.509a.707.707,0,0,0,.372.21.85.85,0,0,0,.137.014.675.675,0,0,0,.161-.019.7.7,0,0,0,.352-.2l6.2-6.5A1.048,1.048,0,0,0,24,53.389a1.029,1.029,0,0,0-.262-.75l-2.529-3.2a1.012,1.012,0,0,0-.8-.386Z" transform="translate(1675 978.954)" fill="#4eccf4"/>
          <path id="패스_5345" className="color-2 attendance-color-2" data-name="패스 5345" d="M296.609,71.071h-3.745L291.355,67.3h2.2a.481.481,0,0,1,.378.182l2.549,3.225A.5.5,0,0,1,296.609,71.071Z" transform="translate(1401.851 961.234)" fill="#009fe3"/>
          <path id="패스_5346" className="color-1 attendance-color-1" data-name="패스 5346" d="M257.5,196.573a.5.5,0,0,1-.137.314l-6.2,6.507a.174.174,0,0,1-.09.049l2.685-6.872Z" transform="translate(1440.957 835.732)" fill="#4eccf4"/>
          <path id="패스_5347" className="color-1 attendance-color-1" data-name="패스 5347" d="M162.262,71.035h-5.433l1.509-3.773h2.41Z" transform="translate(1532.453 961.269)" fill="#4eccf4"/>
          <path id="패스_5348" className="color-3 attendance-color-3" data-name="패스 5348" d="M33.645,67.406l-1.509,3.773H28.39a.5.5,0,0,1,.125-.363l2.545-3.238a.5.5,0,0,1,.374-.169Z" transform="translate(1657.147 961.129)" fill="#d4f7ff"/>
          <path id="패스_5349" className="color-1 attendance-color-1" data-name="패스 5349" d="M34.853,203.586a.174.174,0,0,1-.091-.049l-6.2-6.507a.505.505,0,0,1-.137-.314h3.745Z" transform="translate(1657.115 835.591)" fill="#4eccf4"/>
          <path id="패스_5350" className="color-2 attendance-color-2" data-name="패스 5350" d="M162.264,196.644l-2.685,6.872a.152.152,0,0,1-.062,0l-2.686-6.872Z" transform="translate(1532.452 835.661)" fill="#009fe3"/>
        </g>
      </svg>
    )
  }
}
